namespace advisorop.components.advisor {
    

    class AdvisorNavController {

        $router;
        public sparklineData;
        user: domains.identity.IUser = {};
        currentAdvisor: domains.IAdvisor = {};

        adminModeAvailable: boolean = false; // only if user is Advisory Admin
        adminModeEnabled: boolean = false;
        advisoryRole: string;
        advisoryFirms: domains.IAdvisoryFirm[] = null;
        selAdvisoryFirm: domains.IAdvisoryFirm;
        counters: domains.IAlertCounters;

        advisoryTypeSystemLogin: number;
        servicerTypeSystemLogin: number;
        ppRepWindow: Window;
        laserAppWnd: Window;
        true: boolean = true;
        showRmdTrackerNew: boolean = false;

        static $inject = ["identityService", "advisorService", "generalService", "$rootScope"];
        constructor(private identityService: services.IdentityService,
            private advisorService: services.AdvisorService,
            private generalService: services.GeneralService,
            private $rootScope: ng.IRootScopeService) {

            this.$rootScope.$on('alertCounterChanged', (event: ng.IAngularEvent) => {
                this.counters = this.generalService.getAlertCounters();
            });

            //this.identityService.getUserPromise().then(response => {
            //    this.user = response;
            //});
            this.sparklineData = {
                chart: { caption: "", numberPrefix: "", subCaption: "", theme: "" },
                data: []
            };

            this.advisoryTypeSystemLogin = domains.SystemLoginType.ADVISOR;
            this.servicerTypeSystemLogin = domains.SystemLoginType.SERVICER;

            this.advisoryRole = domains.AdvisoryRoles.ADVISORY.toString();

        }

        logout(): void {
            this.$router.parent.navigate(["Account", "Logout"]);
        }

        setAdminMode(adminModeEnabled: boolean, advisoryFirm: domains.IAdvisoryFirm) {
            if (adminModeEnabled != null && adminModeEnabled != undefined) {

                // adminMode must be available ...
                this.adminModeEnabled = adminModeEnabled && this.adminModeAvailable;

                let adminMode: domains.IAdminMode = {
                    enabled: this.adminModeEnabled /*&& !!advisoryFirm*/,
                    advisoryFirm: !!advisoryFirm ? advisoryFirm : { id: null }
                };
                this.advisorService.setAdminMode(adminMode);

                //broadcast message admin mode is changed
                this.$rootScope.$broadcast("adminModeChanged");
                console.log("Admin mode is changed. Enabled = ", this.adminModeEnabled);
            }
        }

        bindAdminMode() {
          let adminMode = this.advisorService.getAdminMode();

          // this will always be a ENABLED if AdminMode is available
          this.adminModeEnabled = /*!!this.adminModeAvailable; /*/!!adminMode.enabled;
          this.selAdvisoryFirm = adminMode.advisoryFirm;
        }

        // #region TESTING functions
        testDocuSign() {
            this.advisorService.ds_logininformation()
                .then(response => {
                    console.log(`Success: ${response.status} : ${response.data}`);
                })
                .catch(response => {
                    console.log(`${response.status} : ${response.data}`);
                })
        };

        testLaserApp() {

            toastr.warning("This function is disabled.");
            return;

            //if (this.laserAppWnd) {
            //    this.laserAppWnd.close();
            //    this.laserAppWnd = null;
            //}

            //var formGuid = "{C1205DC0-78A7-407D-9959-9E74EC5A7541}";

            //formGuid = window.prompt("Enter LaserAPP form guid", formGuid);

            //this.advisorService.testLaserApp(formGuid)
            //    .then(response => {
            //        console.log("Response from LaserApp test:", response);
            //        this.laserAppWnd = window.open(response.data, "_blank");
            //    }
            //    , err => this.generalService.showError(err));
        };

        openPPReport(report: string): void {
            if (!this.ppRepWindow) {
                this.ppRepWindow = window.open("/samlidp/openppreport/0/HH/" + report, "_blank");
                if (!this.ppRepWindow) {
                    toastr.warning("Your browser blocking popups from this site! Please enable popups for AdvisorOp!");
                }
            }
            else {
                this.ppRepWindow.location.href = "/samlidp/openppreport/0/HH/" + report;
                this.ppRepWindow.focus();
            }
        }
        // #endregion


        $onInit(): void {

            //this.advisorService.getMarketValueByAdvisor().success((data) => {
            //    this.sparklineData = data;
            //}, err => this.generalService.showError(err));

            this.identityService.getUserPromise().then(response => {
                this.user = response;
                this.adminModeAvailable = false;
                if (this.user.advisor && this.user.advisor.id > 0) {
                    this.currentAdvisor = this.user.advisor;
                    // Advisory admins get the admin role unless they are being impersonated... then no admin role will be available
                    this.adminModeAvailable = (this.user.role.indexOf("ADVISORY_ADMIN") >= 0 && this.user.impersonated == false);
                    this.advisoryFirms = this.currentAdvisor.advisoryFirms;
                }

                this.bindAdminMode();
            });
            this.generalService.refreshAlertCounters();

            // Hidden until the answer arrives, and if it never does.
            this.generalService.getRmdTrackerMenuVisible()
                .then(response => this.showRmdTrackerNew = response.data === true);
        }

        $routerOnActivate(next, previous) {
        }
    }



    class AdvisorNav implements ng.IComponentOptions {

        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;
        public $routeConfig: any;

        constructor() {
            this.bindings = {
                "$router": "<"
            };
            this.controller = AdvisorNavController;
            this.controllerAs = "vm";
            this.templateUrl = 'spa/advisor-module/components/advisor-nav.html';
        }
    }
    angular.module(Constants.APP).component("advisorNav", new AdvisorNav());


}